import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { queryClient } from './lib/queryClient';
import { ErrorBoundary } from './lib/error-boundary';
import { ToastProvider } from './components/ui/toast';
import { Toaster } from './components/ui/sonner';
import { applyTheme, readStoredTheme } from './lib/theme';
import { bootstrapAuth } from './lib/auth-bootstrap';
import './index.css';
import './styles/theme.css';

// Apply persisted theme before first paint to avoid a flash.
applyTheme(readStoredTheme());

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('#root not found in index.html');
}

// Rotate a stale persisted access token BEFORE the first protected query runs.
// If the refresh fails we let the lazy 401-handler in api.ts take over from
// there — it'll redirect to /login on the first protected request.
void bootstrapAuth();

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <RouterProvider router={router} />
          <Toaster />
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
